import { Route } from 'react-router-dom';

import { MerchantVideosPage } from './MerchantVideosPage.js';

export function videosRoutes() {
  return (
    <>
      <Route path="/videos" element={<MerchantVideosPage />} />
      <Route path="/videos/line/:productionLineId" element={<MerchantVideosPage />} />
    </>
  );
}
